import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';

// Instead of using totalHeight parameter, just use fixed navigation height
const NAVIGATION_HEIGHT = 80;
export function useScrollDirection() {
  const $ = _c(5);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const updateScrollDirection = () => {
        const scrollY = window.scrollY;
        if (Math.abs(scrollY - lastScrollY.current) < 10) {
          ticking.current = false;
          return;
        }
        const threshold = Math.max(100, NAVIGATION_HEIGHT);
        if (scrollY > lastScrollY.current && scrollY > threshold) {
          setScrollDirection("down");
          setIsVisible(false);
        } else {
          if (scrollY < lastScrollY.current && scrollY > threshold) {
            setScrollDirection("up");
            setIsVisible(true);
          } else {
            if (scrollY <= threshold) {
              setIsVisible(false);
            }
          }
        }
        lastScrollY.current = scrollY > 0 ? scrollY : 0;
        ticking.current = false;
      };
      const onScroll = () => {
        if (!ticking.current) {
          requestAnimationFrame(updateScrollDirection);
          ticking.current = true;
        }
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", onScroll);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isVisible || $[3] !== scrollDirection) {
    t2 = {
      scrollDirection,
      isVisible
    };
    $[2] = isVisible;
    $[3] = scrollDirection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}